define('specific/pushdetails/views/PushDetailsView', [
    'specific/pushdetails/templates/pushdetails',
    'components/factory/Factory'
], function(tpl, Factory) {

    var PushDetailsView = Mazarine.View.extend({

        events: {
            'click .maz-button-previous': 'onClickPrevious',
            'click .maz-button-next': 'onClickNext',
            'click .maz-pushdetails-video-wrapper': 'onClickToggleVideoPlay'
        },

        template: tpl,

        className: 'maz-pushdetails-view',

        productsReady: 0,

        getRenderDatas: function() {
            var obj = this.model.toJSON();
            obj.datas.productWrapperClass = obj.datas.products.length > 1 ? 'multi' : 'simple';
            obj.datas.caption = obj.datas.caption.substring( 0, 120) + '...';
            return obj;
        },

        afterRender: function() {
            this.$el.addClass('maz-loading');
            this.productsReady = 0;
            this.productsToShow = [];

            _.each( this.model.get('datas').products, function( product, index ) {
                var model = null;

                if( this.model.get('config').isPcd ) {
                    model = Factory.createModelFromData({
                        overridePackshotWithCover: true,
                        overridePriceWithSubtitlePlusPrice: true,
                        ecrinHorizonForceKnowmore: true,
                        showSubtitle: false,
                        type: 'productview',
                        viewId: 'productview-' + product.codeY,
                        codeY: product.codeY,
                        defaultSku: product.defaultSku,
                        suffixClass: this.model.get('isMobile') || this.model.get('datas').products.length > 1 ? 'basic-multi' : 'basic-simple', // Simulate multi mode on mobile to handle only one layout
                        showDescription: false,
                        showSwatch: false,
                        showSwatchLabel: false,
                        showKnowmore: true,
                        useNewShadowPackshot: false
                    });
                } else {
                    model = Factory.createModelFromData({
                        type: 'staticproduct',
                        viewId: 'staticproductview-' + product.tag_based_key,
                        suffixClass: this.model.get('isMobile') || this.model.get('datas').products.length > 1 ? 'basic-multi' : 'basic-simple', // Simulate multi mode on mobile to handle only one layout
                        datas: product
                    });

                    var img = new Image();
                    img.onload = function(e) {
                        setTimeout(function(){
                            model.set('isReady', true);

                            clearTimeout(this);
                        }, 200);
                    };
                    img.src = model.get('datas')._embedded.base_image.images.normal;
                }

                var view = Factory.createViewFromModel( model );

                this.listenTo( model, 'change:isReady', _.bind(this.onProductReady, this, index, view));
                //this.$('.maz-pushdetails-product').eq( index ).html( view.render().$el );
            }, this );

            if (this.model.get('datas').products.length <= 0) {
                this.onAllProductsReady();
            }
        },

        onProductReady: function(index, view, model, self) {
            if (!model.get('datas')) {
                // this.$('.maz-pushdetails-product').eq( index ).css('display', 'none');
            } else {
                model.set('isPopinProduct', true);
                this.productsToShow.push({model: model, view: view});
            }

            this.productsReady++;

            if( this.productsReady === this.model.get('datas').products.length ) {
                this.onAllProductsReady();
            }
        },

        onAllProductsReady: function() {

            _.each(this.productsToShow, _.bind(function(item, index){
                item.model.set('suffixClass', this.model.get('isMobile') || this.productsToShow.length > 1 ? 'basic-multi' : 'basic-simple');
                this.$('.maz-pushdetails-product').eq( index ).html( item.view.render().$el );
            }, this));

            var obj = this.getRenderDatas();
            this.$('.maz-pushdetails-products').removeClass('maz-pushdetails-products-' + obj.datas.productWrapperClass);

            obj.datas.productWrapperClass = this.productsToShow.length > 1 ? 'multi' : 'simple';

            this.$('.maz-pushdetails-products').addClass('maz-pushdetails-products-' + obj.datas.productWrapperClass);

            if (this.productsToShow.length <= 0) {
                if (!this.model.get('isMobile')) {
                    this.$('.maz-pushdetails-content-wrapper').addClass('maz-pushdetails-no-products');
                }

                this.$('.maz-pushdetails-products').css('display', 'none');
            }

            if (this.model.get('datas').video_url) {
                this.$('.maz-pushdetails-video-wrapper').append('<video src="' + this.model.get('datas').video_url + '" autoplay="autoplay" controls="controls"  controlsList="nodownload" height="auto" width="100%"/>');
            }

            this.model.set('isReady', true);
            this.$el.removeClass('maz-loading');

            this.$el.find('.maz-product-packshot').on('click', function(){
                $(this).parent().find('.maz-product-knowmore')[0].click();
            });
            this.$el.find('.maz-product-hgroup').on('click', function(){
                $(this).parent('.maz-product-info ').find('.maz-product-knowmore')[0].click();
            });
            this.$el.find('.maz-product-submit').on('click', function(e){
                e.stopPropagation();
                e.preventDefault();
                $(this).parents('.maz-product-info').find('.maz-product-knowmore')[0].click();
            });
        },

        onClickPrevious: function( e ) {
            e.preventDefault();

            var callback = this.model.get('handleClickPrevious');
            if( callback && !$( e.currentTarget ).hasClass('maz-disabled') ) {
                callback();
            }
        },

        onClickToggleVideoPlay: function( e ) {
            var video = e.currentTarget.querySelector('video');

            if (video.paused) {
                video.play();
                $(e.currentTarget).addClass('maz-playing');
            } else {
                video.pause();
                $(e.currentTarget).removeClass('maz-playing');
            }
        },

        onClickNext: function( e ) {
            e.preventDefault();

            var callback = this.model.get('handleClickNext');
            if( callback && !$( e.currentTarget ).hasClass('maz-disabled') ) {
                callback();
            }
        }
    });

    return PushDetailsView;
});
